import * as React from 'react';

const SvgCustomChina = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 30 20'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}
	>
		{/* 배경 빨간색 */}
		<rect width='30' height='20' fill='#de2910' />

		{/* 큰 별 */}
		<polygon
			fill='#ffde00'
			points='5,2 5.588,3.809 7.5,3.809 5.956,5.015 6.544,6.824 5,5.618 3.456,6.824 4.044,5.015 2.5,3.809 4.412,3.809'
		/>

		{/* 작은 별 1 */}
		<polygon
			fill='#ffde00'
			transform='rotate(30, 10, 2)'
			points='10,2 10.294,2.618 11,2.618 10.441,3.062 10.735,3.68 10,3.236 9.265,3.68 9.559,3.062 9,2.618 9.706,2.618'
		/>

		{/* 작은 별 2 */}
		<polygon
			fill='#ffde00'
			transform='rotate(15, 11, 4)'
			points='11,4 11.294,4.618 12,4.618 11.441,5.062 11.735,5.68 11,5.236 10.265,5.68 10.559,5.062 10,4.618 10.706,4.618'
		/>

		{/* 작은 별 3 */}
		<polygon
			fill='#ffde00'
			transform='rotate(0, 11, 6)'
			points='11,6 11.294,6.618 12,6.618 11.441,7.062 11.735,7.68 11,7.236 10.265,7.68 10.559,7.062 10,6.618 10.706,6.618'
		/>

		{/* 작은 별 4 */}
		<polygon
			fill='#ffde00'
			transform='rotate(-15, 10, 8)'
			points='10,8 10.294,8.618 11,8.618 10.441,9.062 10.735,9.68 10,9.236 9.265,9.68 9.559,9.062 9,8.618 9.706,8.618'
		/>
	</svg>
);

export default SvgCustomChina;
